import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import AccountForm from 'components/adm/account/accountForm';
import Message from 'components/parts/message';
import { registAccount } from 'actions/accountAction';
import { clearMessage, setMessage} from 'actions/messageAction';
import { lang } from 'lang';

/**
 * 管理者アカウント登録画面
 */
const AdmAccountRegist = (props) => {
  const { msg, error, word, validate } = lang;
  const dispatch = useDispatch();
  const { register, handleSubmit, formState, errors } = useForm({mode: 'onChange'});
  // グローバルステートから管理者アカウント情報を取得する
  const accountState = useSelector((state) => state.account);

  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => (
    // メッセージクリア
    dispatch(clearMessage())
  ), [React.useRef()]);

  // 登録ボタンが押されたときに実行される
  const onSubmit = async params => {
    // メッセージクリア
    dispatch(clearMessage());
    // メールアドレスが既に登録済みであるかをチェックする
    const item = accountState.items.filter(item => item.email === params.email);
    if (item.length === 1) {
      dispatch(setMessage('warning', validate.registered.replace('%s', word.mail_address)));
      return false;
    }

    let isSuccess = false;
    // 管理者アカウントを登録する
    await dispatch(
      await registAccount(params)
    ).then((result) => {
      // Success
      if (result.status === 200) {
        props.history.replace({
          pathname: '/adm/accounts',
          state: { 
            keepMessage: true,  // 一覧画面表示時にメッセージを残す
            message: {
              type: 'success',
              msg: msg.account.regist,
            }
          }
        });
        isSuccess = true;
      // Warning
      } else if (result.status === 400) {
        // メールアドレスが既に登録済み
        if (result.errcode === 'EMAIL_ALREADY_EXISTS') {
          dispatch(setMessage('warning', validate.registered.replace('%s', word.mail_address)));
        // 電話番号が正しくない
        } else if (result.errcode === 'INVALID_PARAMETER_PHONE_NUMBER') {
          dispatch(setMessage('warning', validate.invalid_phone_number));
        }
      // Error
      } else {
        dispatch(setMessage('danger', error.account.regist + `\n${result.errcode}`));
      }
    });
    return isSuccess;
  };

  return (
    <div className="col-10 pt-3 pb-3">
      <Message/>
      <AccountForm 
        isUpdate={false}
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        formState={formState}
        errors={errors}
      />
    </div>
  );
};
AdmAccountRegist.propTypes = {
  history: PropTypes.object
};
export default AdmAccountRegist;
